import { render, staticRenderFns } from "./SetupInternalApiHarvester.vue?vue&type=template&id=0c163462&"
import script from "./SetupInternalApiHarvester.vue?vue&type=script&lang=ts&"
export * from "./SetupInternalApiHarvester.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports